export const PRICING_PRESET_SQFT_SEG = "pricing-presets/add-line-sqft";
export const PRICING_PRESET_SLAB_SEG = "pricing-presets/set-slab";
export const PRICING_PRESET_PKG_SEG = "pricing-presets/add-pkg";
export const PRICING_PRESET_PLUS_SQFT_SEG = "pricing-presets/add-plus-sqft";
export const PRICING_PRESET_PLUS_PKG_SEG = "pricing-presets/add-plus-pkg";
export const PRICING_PRESET_MIN_SEG = "pricing-presets/add-min";